import React from "react";

const Footer = () => {
  return (
    <div className="footerbar">
      <p>Doris's Portfolio © 2025 Copyright</p>
    </div>
  );
};

export default Footer;
